var _instanceUrl = null;
var _site = null;
export function instanceUrl() {
  return _instanceUrl;
}
export function site() {
  return _site;
}
export default {
  /**
   * @param {string} instanceUrl Adaptive url
   * @param {number} [site] Adaptive CMS site number (if not set, default is 0)
   */
  init: function init(instanceUrl, site) {
    if (site === void 0) {
      site = 0;
    }
    _instanceUrl = instanceUrl;
    _site = site;
  }
};